import { ReactNode } from 'react';

import { SkeletonBase } from '@unified-checkout/design-system';

import styles from './LabelCardInfo.module.scss';

const LabelCardInfo = ({
  label,
  children,
  isFetching,
  onClickHandler,
  wrapperClassName,
}: {
  label: string;
  children: ReactNode;
  isFetching?: boolean;
  onClickHandler?: () => void;
  wrapperClassName?: string;
}) => {
  return (
    <div
      className={`${styles['settings-card-info']} ${wrapperClassName || ''}`}
      onClick={onClickHandler}
    >
      <div className={styles['settings-card-info__title']}>
        {isFetching ? (
          <SkeletonBase height="20px" />
        ) : (
          <span className={styles['settings-card-info__title-text']}>
            {label}
          </span>
        )}
      </div>

      <div className={styles['settings-card-info__content']}>{children}</div>
    </div>
  );
};

export default LabelCardInfo;
